import React from 'react'
import PropTypes from 'prop-types'
import { Chip } from '@mui/material'
import { getContrastRatio } from '@mui/material/styles'

const HEX_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/

/**
 * chipColor is the operation status's #rrggbb text color, configured in
 * Forcyte; the background is the same color mixed 15% into white. A color too
 * pale to read on white flips: dark text on the color itself.
 */
const getPalette = chipColor => {
  if (!HEX_COLOR_PATTERN.test(chipColor || '')) {
    return { backgroundColor: 'grey.200', color: 'text.primary' }
  }
  if (getContrastRatio(chipColor, '#fff') < 1.5) {
    return { backgroundColor: chipColor, color: '#2d2d2e' }
  }
  return {
    backgroundColor: `color-mix(in srgb, ${chipColor} 15%, white)`,
    color: chipColor,
  }
}

export const OperationStatusChip = ({ label, chipColor, size = 'small' }) => {
  if (!label) return null

  const palette = getPalette(chipColor)

  return (
    <Chip
      size={size}
      label={label}
      sx={{
        fontWeight: 600,
        fontSize: '0.75rem',
        height: 24,
        backgroundColor: palette.backgroundColor,
        color: palette.color,
        '& .MuiChip-label': { px: 1 },
      }}
    />
  )
}

OperationStatusChip.propTypes = {
  label: PropTypes.string,
  chipColor: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
}
